// extracted by mini-css-extract-plugin
module.exports = {"rule":"styles_rule__Kfx2F","propertySelect":"styles_propertySelect__1WunM"};